import { Button, Flex, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import { ReviewData, UserReviewSubmitData } from "./Review.types";
import AwesomeIcon from "components/common/AwesomeIcon";
import { faGoogle } from "@fortawesome/free-brands-svg-icons";

const ReviewButtons = ({ 
    reviewData, 
    submitData, 
    onButtonClick,
    isLoading,
    disabled 
}: { 
    reviewData: ReviewData, 
    submitData: UserReviewSubmitData,
    onButtonClick?: (platform: string) => void,
    isLoading?: boolean,
    disabled?: boolean
}) => {

    const handleCopyAndGo = (platform: string) => {
        if (onButtonClick) {
            onButtonClick(platform);
            return;
        }

        navigator.clipboard.writeText(submitData.review || "");

        const getLink = () => {
            switch (platform) {
                case "Google":
                    return reviewData.google_button_link || "https://google.com";
                case "Booksy":
                    return reviewData.booksy_button_link || "https://booksy.com";
            }
        }

        if (window.self === window.top) {
            window.location.href = getLink() || "";
        } else {
            window.parent.postMessage({
                type: "ftRedirect",
                link: getLink() || ""
            }, "*");
        }
    }

    return (
        <Flex vertical align="center" gap="small">
            {!onButtonClick && (
                <Typography.Title level={2}>
                    <FormattedMessage
                        id="standalone.reviews.feedbackFormThankYouMessage"
                        defaultMessage="Thank you for your review!"
                        description="Reviews: Wiadomość po dobrej ocenie"
                    />
                </Typography.Title>
            )}
            {
                reviewData.google_button_link &&
                <Button
                    type="primary"
                    shape="round"
                    size="large"
                    onClick={() => handleCopyAndGo("Google")}
                    loading={isLoading}
                    disabled={isLoading || disabled}
                >
                    <AwesomeIcon icon={faGoogle} />
                    <FormattedMessage
                        id="standalone.reviews.editor.copyAndGo"
                        defaultMessage="Copy and go to {platform}"
                        description="Reviews: Przycisk do skopiowania linku i przejścia do Google"
                        values={{
                            platform: "Google"
                        }}
                    />
                </Button>}
            {
                reviewData.booksy_button_link &&
                <Button
                    type="primary"
                    shape="round"
                    size="large"
                    onClick={() => handleCopyAndGo("Booksy")}
                    loading={isLoading}
                    disabled={isLoading || disabled}
                >
                    <FormattedMessage
                        id="standalone.reviews.editor.copyAndGo"
                        defaultMessage="Copy and go to {platform}"
                        description="Reviews: Przycisk do skopiowania linku i przejścia do Booksy"
                        values={{
                            platform: "Booksy"
                        }}
                    />
                </Button>
            }
        </Flex>
    )





}


export default ReviewButtons;